import React from 'react'
import styled from 'styled-components'

import { ICellResult } from '../types/common'
import ResultRow from './result-row'
import ResultLabels from './result-labels'

interface IProps {
  selectedPlayers: Array<{ firstName: string; lastName: string; cells: ICellResult[] }>
}

export default function ResultsTable({ selectedPlayers }: IProps) {
  return (
    <Container>
      <ResultLabels />
      {selectedPlayers.map((selectedPlayer) => (
        <ResultRow key={`${selectedPlayer.firstName}-${selectedPlayer.lastName}`} selectedPlayer={selectedPlayer} />
      ))}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
